import Vue from 'vue';

import { Translate } from './shared/mixins';

export default [Vue.mixin(Translate)];
